import { appConfig } from "../config";
import {apiRequest} from "../util/ApiUtils";


export interface Automation {
    id: string;
    name: string;
    description: string;
    enabled: boolean;
    conditions: RuleCondition[];
    actions: RuleAction[];
}

export interface RuleCondition {
    id: number;
}

export interface RuleAction {
    id: number;
}

const backendUrl = appConfig.backendUrl;

export async function retrieveAutomations(): Promise<Automation[]> {

    const data = await apiRequest(`${backendUrl}/api/automations`, {
        method: 'GET'
    });

    return data as Automation[];
}